import React, { FC, memo, useEffect, useState } from 'react';
import { MdAttachFile as FileIcon } from '@react-icons/all-files/md/MdAttachFile';
import useDocument from 'src/hooks/api/useDocument';
import Document from 'src/interfaces/api/Document';
import { Skeleton } from '@material-ui/lab';
import { Box, Link } from '@material-ui/core';
import api from 'src/config/api';

interface Props {
  documentId: string;
}

const Attachment: FC<Props> = ({ documentId }) => {
  const { getDocuments } = useDocument();
  const [document, setDocument] = useState<Document>();

  useEffect(() => {
    getDocuments([documentId]).then((collection) => {
      if (collection.total <= 0) {
        throw new Error('Document introuvable.');
      }
      setDocument(collection.items[0]);
    });
  }, [documentId]);

  return (
    <Box display='flex' alignItems='center' mr='5px !important' mb='5px !important' clone>
      <Link href={api.document.download(documentId).endpoint} color='inherit'>
        <FileIcon size={16} /> {document ? <span>{document.filename}</span> : <Skeleton width={100} />}
      </Link>
    </Box>
  );
};

export default memo(Attachment, (prevProps, nextProps) => prevProps.documentId === nextProps.documentId);
